import axios from 'axios';
// config
import { api } from '../configs';

// -----------------------------------------------

const axiosInstance = axios.create({
  baseURL: api.HOST,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
